import React, { FC } from 'react';
import styled from 'styled-components';
import { MainLayout } from 'src/pages-all/master-page/components/main-layout';
import { colors } from 'styles/colors';
import { MainContent } from 'src/pages-all/master-page/components/main-content';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import { SubSectionHeadline } from './parts/default.parts';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { ActionButton } from './ActionButton';
import { Text } from '../../../components/text/Text';
import { useLocalizedI18nGlobal } from '../../../logic/translations/use-localized-i18n-global';

const Section = styled(MainLayout)<{ backgroundColor?: string }>`
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? backgroundColor : colors.lightTeal};
  padding: 0 16px;
`;

const Content = styled.div<any>`
  display: flex;
  flex-direction: ${({ minDesktop }) => (minDesktop ? 'row' : 'column')};
  justify-content: center;
  align-items: center;
  margin: 0 0 40px 0;
`;

const Description = styled.div<any>`
  margin: 80px 0 0 0;
`;

export const RefugeesWeNeedHelp: FC<{ backgroundColor?: string }> = ({ backgroundColor }) => {
  useLocalizedI18nGlobal();
  const { minDesktop, minTablet } = useBreakpoints();

  return (
    <Section id={'premium'} backgroundColor={backgroundColor}>
      <MainContent style={{ alignItems: 'center' }}>
        <Content minDesktop={minDesktop}>
          <SubSectionHeadline
            headline={translate(translationKeys.homepage.refugeesWeNeedHelp.heading)}
            center
          >
            <Description>
              <Text fontWeight={600} size={minTablet ? 24 : 16} textAlign={'center'}>
                {translate(translationKeys.homepage.refugeesWeNeedHelp.description)}
              </Text>
            </Description>

            <ActionButton
              onClick={() => {
                window.location.href = 'mailto:ukraine@tutorspace.de';
              }}
              style={{ margin: '40px auto 0 auto' }}
            >
              {translate(translationKeys.homepage.refugeesWeNeedHelp.button)}
            </ActionButton>
          </SubSectionHeadline>
        </Content>
      </MainContent>
    </Section>
  );
};
